import i18n from 'i18next'
import { initReactI18next } from 'react-i18next'
import LanguageDetector from 'i18next-browser-languagedetector'
import Cookies from 'js-cookie'

import koTranslation from '../locales/ko.json'
import enTranslation from '../locales/en.json'

/*********************
 * 🌐 i18n 초기화 설정
 *
 * - 한글(ko)과 영어(en) 지원
 * - 기본 언어: 한글
 * - 브라우저 언어 자동 감지 기능 활성화
 * - 쿠키에 선택한 언어 저장 (EXGO_LANG)
 *********************/

const resources = {
  ko: {
    translation: koTranslation,
  },
  en: {
    translation: enTranslation,
  },
} as const

/*********************
 * 🍪 쿠키 기반 언어 감지 플러그인
 * - 쿠키에서 언어 읽기/쓰기
 * - 쿠키 이름: EXGO_LANG
 * - 유효기간: 365일
 *********************/
const languageDetector = new LanguageDetector()
languageDetector.addDetector({
  name: 'cookieDetector',
  lookup() {
    return Cookies.get('EXGO_LANG')
  },
  cacheUserLanguage(lng: string) {
    Cookies.set('EXGO_LANG', lng, { expires: 365 })
  },
})

i18n
  .use(languageDetector)
  .use(initReactI18next)
  .init({
    resources,
    fallbackLng: 'ko',
    lng: Cookies.get('EXGO_LANG') || 'ko',
    debug: false,

    /*********************
     * 📦 언어 감지 옵션
     * - 쿠키에서 저장된 언어 우선 사용 (EXGO_LANG)
     * - 없으면 브라우저 언어 확인
     * - 그래도 없으면 fallback(ko) 사용
     *********************/
    detection: {
      order: ['cookieDetector', 'navigator'],
      caches: ['cookieDetector'],
    },

    interpolation: {
      escapeValue: false,
    },

    /*********************
     * ⚙️ React 옵션
     * - Suspense 모드 비활성화 (동기 로딩)
     *********************/
    react: {
      useSuspense: false,
    },
  })

export default i18n

/*********************
 * 📝 타입 정의
 * - 자동완성을 위한 리소스 타입
 *********************/
export type Language = 'ko' | 'en'

export const SUPPORTED_LANGUAGES: Language[] = ['ko', 'en']

export const LANGUAGE_LABELS: Record<Language, string> = {
  ko: '한국어',
  en: 'English',
}
